/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var fetch = MoyaContainer.get('core.fetch');
    MoyaEventHandler.on('mainmenu.init', function () {
        fetch.fetchJson('/_/moya/html/ajax/sitemapExtra/')
            .then(function (res) {
            injectExtraInfo(res.entries);
        });
    });
    function injectExtraInfo(entries) {
        var level1 = document.querySelectorAll('.mmLevel1 >.children');
        level1.forEach(function (node) {
            var info = findExtraInfoForNode(node, entries);
            if (!info) {
                return;
            }
            var megamenuWrap = node.querySelector('.megamenu >.wrap');
            var btn = document.createElement('button');
            if (megamenuWrap) {
                btn.setAttribute('id', 'closeMenu');
                megamenuWrap.append(btn);
            }
            var megamenu = node.querySelector('.megamenu >.wrap >.contentWrap');
            var extraInfoWrap = document.createElement('div');
            extraInfoWrap.classList.add('info');
            var extraTitle = document.createElement('div');
            extraTitle.classList.add('title');
            if (info.title === 'Keilir') {
                var titleHref = document.createElement('a');
                titleHref.href = "/" + info.division;
                titleHref.append(info.title);
                extraTitle.append(titleHref);
            }
            else {
                extraTitle.append(info.title);
            }
            extraInfoWrap.append(extraTitle);
            if (info.extraInfo) {
                var extraInfo = document.createElement('div');
                extraInfo.classList.add('description');
                extraInfo.append(info.extraInfo);
                extraInfoWrap.append(extraInfo);
            }
            if (megamenu) {
                megamenu.insertAdjacentElement('afterbegin', extraInfoWrap);
            }
        });
    }
    function findExtraInfoForNode(node, entries) {
        return entries.filter(function (entry) {
            return node.classList.contains(entry.class) && node.classList.contains(entry.division);
        }).shift();
    }

}());
typeof tsBuild === 'function' && tsBuild();})();
